var map = {
	"./template.betgalaxy": 1068,
	"./template.betgalaxy.tsx": 1068,
	"./template.betprofessor": 1069,
	"./template.betprofessor.tsx": 1069,
	"./template.betroyale": 2112,
	"./template.betroyale.tsx": 2112,
	"./template.default": 655,
	"./template.default.tsx": 655,
	"./template.fiestabet": 2013,
	"./template.fiestabet.tsx": 2013,
	"./template.forsport": 1070,
	"./template.forsport.tsx": 1070,
	"./template.puntcity": 1071,
	"./template.puntcity.tsx": 1071,
	"./template.puntgenie": 1072,
	"./template.puntgenie.tsx": 1072,
	"./template.questbet": 1073,
	"./template.questbet.tsx": 1073,
	"./template.ts": 287,
	"./template.volcanobet": 1074,
	"./template.volcanobet.tsx": 1074,
	"./template.wellbet": 2113,
	"./template.wellbet.tsx": 2113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;